import { render, staticRenderFns } from "./VolunteerProfileTable.vue?vue&type=template&id=ea6cb2b2"
import script from "./VolunteerProfileTable.vue?vue&type=script&lang=ts"
export * from "./VolunteerProfileTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports